module.exports = __webpack_public_path__ + "static/img/logo5.95438e65.png";